import React from 'react'
import { Box } from 'components/layout/box'
import { Skeleton } from '@radix-ui/themes'
import * as styles from './BotCard.css'

export const BotCardSkeleton = () => {
	return (
		<Box className={styles.cardWrapper}>
			<Box className={styles.card}>
				<Box display="flex" flexDirection="column" gap={4} flexGrow={1} justifyContent="space-between">
					<Box className={styles.mainCardGrid}>
						{/* Avatar Skeleton */}
						<Box className={styles.avatarWrapper}>
							<Skeleton style={{ width: '88px', height: '88px', borderRadius: '50%' }} />
							<Skeleton style={{ width: '60px', height: '12px', borderRadius: '12px' }} />
						</Box>

						{/* Content Skeleton */}
						<Box display="flex" flexDirection="column" gap={4}>
							{/* Header Skeleton */}
							<Box className={styles.headerWrapper}>
								<Skeleton style={{ width: '50%', height: '24px', borderRadius: '4px' }} />
							</Box>

							{/* Info Grid Skeleton */}
							<Box className={styles.infoGrid}>
								{/* Details Mid */}
								<Box>
									<Skeleton style={{ width: '80%', height: '20px', borderRadius: '4px', marginBottom: '8px' }} />
									<Skeleton style={{ width: '70%', height: '20px', borderRadius: '4px', marginBottom: '8px' }} />
									<Skeleton style={{ width: '60%', height: '20px', borderRadius: '4px' }} />
								</Box>

								{/* Details Grid */}
								<Box className={styles.detailsGrid}>
									<Skeleton style={{ width: '80%', height: '20px', borderRadius: '4px' }} />
									<Skeleton style={{ width: '80%', height: '20px', borderRadius: '4px' }} />
									<Skeleton style={{ width: '80%', height: '20px', borderRadius: '4px' }} />
									<Skeleton style={{ width: '80%', height: '20px', borderRadius: '4px' }} />
								</Box>
							</Box>
						</Box>
					</Box>

					{/* Trade News Skeleton */}
					<Box>
						<Skeleton style={{ width: '100%', height: '80px', borderRadius: '8px' }} />
					</Box>
				</Box>
				<Box className={styles.showMoreButton}>
					<Skeleton style={{ width: '50%', height: '12px', borderRadius: '4px' }} />
				</Box>
			</Box>
		</Box>
	)
}
